import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type WithoutChild<T> = T extends { child?: any } ? Omit<T, "child"> : T
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type WithoutChildren<T> = T extends { children?: any }
  ? Omit<T, "children">
  : T
export type WithoutChildrenOrChild<T> = WithoutChildren<WithoutChild<T>>
export type WithElementRef<T, U extends HTMLElement = HTMLElement> = T & {
  ref?: U | null
}

export function formatTaskLimit(
  minInstances?: number | null,
  maxInstances?: number | null,
): string {
  if (!minInstances && !maxInstances) {
    return ""
  }

  if (minInstances && maxInstances) {
    if (minInstances === maxInstances) {
      return `${minInstances}/week`
    }
    return `${minInstances}-${maxInstances}/week`
  }

  if (maxInstances) {
    return `≤${maxInstances}/week`
  }

  if (minInstances) {
    return `${minInstances}+/week`
  }

  return ""
}
